import { type PropsWithChildren } from 'react';

import { getText } from '@storebrand-digital/fms-translations';

import { AGE_REQUIREMENT_FOR_REGULAR_BANKING_PRODUCTS } from '@app/constants/constants';

export default function AgeRedirectorGuard({
  children,
  customerAge,
}: PropsWithChildren<{ customerAge: number | null | undefined }>) {
  if (typeof customerAge === 'number' && customerAge < AGE_REQUIREMENT_FOR_REGULAR_BANKING_PRODUCTS) {
    window.location.href = getText('notEligibleForRegularBanking.href');
    return null;
  }

  return <>{children}</>;
}
